import InfoIcon from '@mui/icons-material/Info';
import DialogInfo from "../_subcomponents/DialogInfo";
import {useContext, useState} from "react";
import AuthContext from "../../context/AuthContext";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import {LightTooltip} from "../_subcomponents/MapToolsBase";
import DialogDeleteMap from "../_subcomponents/DialogDeleteMap";


export default function TmplTools(props: any) {
    let {user, authTokens, serverIP, userPermissions} = useContext(AuthContext)

    let {keyDataSet, mapInfo} = props

    const [infoOpen, setInfoOpen] = useState(false);

    const [delOpen, setDelOpen] = useState(false);

    const redirectAfterDel: any = '../1'

    return (
        <>
            {/* Delete template */}
            <DialogDeleteMap
                open={delOpen}
                setOpen={setDelOpen}
                keyDataSet={keyDataSet}
                redirectTo={redirectAfterDel}
            />
            <LightTooltip title="Delete Mapping">
                <DeleteOutlineIcon
                    color="action"
                    className={userPermissions.canEdit ? "icon-clickable": "icon-nonclickable"}
                    onClick={userPermissions.canEdit ? () => setDelOpen(true) : undefined}
                />
            </LightTooltip>


            {/* Mapping Info */}
            <DialogInfo
                open={infoOpen}
                setOpen={setInfoOpen}
                mapInfo={mapInfo}
            />
            <LightTooltip title="Mapping Info">
                <InfoIcon
                    color="action"
                    className="icon-clickable"
                    onClick={() => setInfoOpen(true)}
                />
            </LightTooltip>

        </>
    )
}